import AppleIcon from '../icons/profiles/AppleIcon';
import FacebookIcon from '../icons/profiles/FacebookIcon';
import ChampionatIcon from '../icons/profiles/ChampionatIcon';
import GoogleIcon from '../icons/profiles/GoogleIcon';
import InstagramIcon from '../icons/profiles/InstagramIcon';
import LivejournalIcon from '../icons/profiles/LivejournalIcon';
import MailruIcon from '../icons/profiles/MailruIcon';
import OdnoklassnikiIcon from '../icons/profiles/OdnoklassnikiIcon';
import PgumosruIcon from '../icons/profiles/PgumosruIcon';
import RamblerIcon from '../icons/profiles/RamblerIcon';
import TwitterIcon from '../icons/profiles/TwitterIcon';
import VkontakteIcon from '../icons/profiles/VkontakteIcon';
import SberbankIcon from '../icons/profiles/SberbankIcon';
export default {
  apple: AppleIcon,
  facebook: FacebookIcon,
  championat: ChampionatIcon,
  google: GoogleIcon,
  instagram: InstagramIcon,
  livejournal: LivejournalIcon,
  mailru: MailruIcon,
  odnoklassniki: OdnoklassnikiIcon,
  pgumosru: PgumosruIcon,
  rambler: RamblerIcon,
  sberbank: SberbankIcon,
  twitter: TwitterIcon,
  vkontakte: VkontakteIcon
};